// extracted by mini-css-extract-plugin
export default {"aboutContainer":"about_aboutContainer__pbQ2J","socialLink":"about_socialLink__Cz1Wk"};